"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var prop_types_1 = tslib_1.__importDefault(require("prop-types"));
var lodash_1 = require("lodash");
var constants_1 = require("playable/dist/src/constants");
var PlayerAPIFacade = /** @class */ (function (_super) {
    tslib_1.__extends(PlayerAPIFacade, _super);
    function PlayerAPIFacade(props) {
        var _this = _super.call(this, props) || this;
        _this.unbindEvents = function () {
            var eventEmitter = _this.props.eventEmitter;
            (0, lodash_1.forEach)(_this.listeners, function (handler, event) {
                eventEmitter.off(event, handler);
                delete _this.listeners[event];
            });
        };
        _this.addListener = function (event, handler) {
            var eventEmitter = _this.props.eventEmitter;
            var wrappedHandler = function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                if (_this._isMounted) {
                    handler.apply(void 0, tslib_1.__spreadArray([], tslib_1.__read(args), false));
                }
            };
            _this.listeners[event] = wrappedHandler;
            eventEmitter.on(event, wrappedHandler);
        };
        _this.setPlaybackStatusState = function (_a) {
            var nextState = _a.nextState;
            _this.setState({
                isVideoEnded: nextState === constants_1.EngineState.ENDED,
                isVideoPaused: nextState === constants_1.EngineState.PAUSED,
                isVideoPlaying: nextState === constants_1.EngineState.PLAYING,
            });
            _this.props.onPlaybackStateChanged(nextState);
        };
        _this.showMainBlockControls = function () {
            _this.setState({
                isControlsShown: true,
            });
        };
        _this.hideMainBlockControls = function () {
            _this.setState({
                isControlsShown: false,
            });
        };
        _this.setFullScreenState = function (isPlayerInFullScreen) {
            _this.setState({ isPlayerInFullScreen: isPlayerInFullScreen });
            _this.props.onFullScreenChanged(Boolean(isPlayerInFullScreen));
        };
        _this.hidePlayerUI = function () {
            var _a = _this.props, mainUIBlock = _a.mainUIBlock, cards = _a.cards;
            mainUIBlock.disableShowingContent();
            mainUIBlock.hide();
            cards.hide();
        };
        _this.showPlayerUI = function () {
            var _a = _this.props, mainUIBlock = _a.mainUIBlock, cards = _a.cards;
            mainUIBlock.enableShowingContent();
            mainUIBlock.show();
            cards.show();
        };
        _this.exitFullScreen = function () {
            var fullScreenManager = _this.props.fullScreenManager;
            if (fullScreenManager.isInFullScreen) {
                fullScreenManager.exitFullScreen();
            }
        };
        _this.pauseVideo = function () {
            var engine = _this.props.engine;
            engine.pause();
        };
        _this._isMounted = false;
        _this.listeners = {};
        _this.state = {
            isVideoEnded: false,
            isVideoPaused: true,
            isControlsShown: false,
            isPlayerInFullScreen: false,
        };
        _this.bindEvents();
        return _this;
    }
    PlayerAPIFacade.prototype.componentDidMount = function () {
        this._isMounted = true;
    };
    PlayerAPIFacade.prototype.componentWillUnmount = function () {
        this.unbindEvents();
        this._isMounted = false;
    };
    PlayerAPIFacade.prototype.bindEvents = function () {
        var _a, _b;
        var _this = this;
        var _c = this.props, onError = _c.onError, onPlayAbort = _c.onPlayAbort, onSeek = _c.onSeek, onUserSeek = _c.onUserSeek, onMute = _c.onMute, onVolumeChange = _c.onVolumeChange;
        var uiHandlers = (_a = {},
            _a[constants_1.UI_EVENTS.MAIN_BLOCK_SHOW] = this.showMainBlockControls,
            _a[constants_1.UI_EVENTS.MAIN_BLOCK_HIDE] = this.hideMainBlockControls,
            _a[constants_1.UI_EVENTS.FULL_SCREEN_STATE_CHANGED] = this.setFullScreenState,
            _a[constants_1.UI_EVENTS.PROGRESS_CHANGE] = onUserSeek,
            _a[constants_1.UI_EVENTS.GO_BACKWARD_WITH_KEYBOARD] = onUserSeek,
            _a[constants_1.UI_EVENTS.GO_FORWARD_WITH_KEYBOARD] = onUserSeek,
            _a);
        var videoHandlers = (_b = {},
            _b[constants_1.VIDEO_EVENTS.STATE_CHANGED] = this.setPlaybackStatusState,
            _b[constants_1.VIDEO_EVENTS.ERROR] = onError,
            _b[constants_1.VIDEO_EVENTS.PLAY_ABORTED] = onPlayAbort,
            _b[constants_1.VIDEO_EVENTS.SEEK_IN_PROGRESS] = onSeek,
            _b[constants_1.VIDEO_EVENTS.MUTE_CHANGED] = onMute,
            _b[constants_1.VIDEO_EVENTS.VOLUME_CHANGED] = onVolumeChange,
            _b);
        (0, lodash_1.entries)(tslib_1.__assign(tslib_1.__assign({}, uiHandlers), videoHandlers)).forEach(function (_a) {
            var _b = tslib_1.__read(_a, 2), eventName = _b[0], handler = _b[1];
            _this.addListener(eventName, handler);
        });
    };
    PlayerAPIFacade.prototype.render = function () {
        var _this = this;
        var children = this.props.children;
        return (react_1.default.createElement("section", null, react_1.default.Children.map(children, function (child) {
            return child
                ? react_1.default.cloneElement(child, tslib_1.__assign(tslib_1.__assign({}, _this.state), { pauseVideo: _this.pauseVideo, exitFullScreen: _this.exitFullScreen, hidePlayerUI: _this.hidePlayerUI, showPlayerUI: _this.showPlayerUI }))
                : child;
        })));
    };
    PlayerAPIFacade.dependencies = [
        'engine',
        'eventEmitter',
        'fullScreenManager',
        'mainUIBlock',
        'cards',
    ];
    PlayerAPIFacade.propTypes = {
        eventEmitter: prop_types_1.default.object,
        engine: prop_types_1.default.object,
        fullScreenManager: prop_types_1.default.object,
        cards: prop_types_1.default.object,
        children: prop_types_1.default.node,
        mainUIBlock: prop_types_1.default.object,
        onFullScreenChanged: prop_types_1.default.func,
        onError: prop_types_1.default.func,
        onPlayAbort: prop_types_1.default.func,
        onMute: prop_types_1.default.func,
        onVolumeChange: prop_types_1.default.func,
        onSeek: prop_types_1.default.func,
        onUserSeek: prop_types_1.default.func,
    };
    PlayerAPIFacade.defaultProps = {
        onSeek: lodash_1.noop,
        onUserSeek: lodash_1.noop,
        onError: lodash_1.noop,
        onPlayAbort: lodash_1.noop,
        onMute: lodash_1.noop,
        onVolumeChange: lodash_1.noop,
        onPlaybackStateChanged: lodash_1.noop,
    };
    return PlayerAPIFacade;
}(react_1.default.Component));
exports.default = PlayerAPIFacade;
//# sourceMappingURL=player-api-facade.js.map